$(document).ready(function (){
  $(".open").click(function (){
    $(".pop-outer").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".pop-outer").fadeOut("slow");
  });
});


$(".text-wrapper").each(function() {
     var html = $(this).html().split(" ");
     html = html.slice(0,40).join(" ") + '<span class="dots">...</span><div class="full-text">' + html.slice(40).join(" ");
     $(this).html(html);
});

$('.full-text').hide();

$('.readmore-btn').click(function (event) {
    event.preventDefault();
    var dots_visibility = $(this).siblings(".text-wrapper").find("span.dots");
    dots_visibility.html(dots_visibility.html() == '...' ? ' ' : '...')
    $('.text-wrapper > p.p1').contents().unwrap();
    $(this).parent().find('.full-text').toggle();
    $(this).html($(this).html() == 'Read less' ? 'Read more' : 'Read less');
});
